import RoleBasedRoute from './role-based-route-container'
export default RoleBasedRoute
